export enum ACTORS {
  SDK = 'SDK',
  PREVIEW = 'PREVIEW',
}

export type Actor = ACTORS;
